export class MakeModel {
  id: number;
  name: string;
  isActive = true;
  createdBy?: string;
  requiresAudit = false;
}
